import React from 'react'

function ProfilePaymentCard() {
    return (
        <div>
    <div className="relative z-20 bg-white rounded-2xl p-4 h-auto">
        <div className="flex flex-col text-brand-primary">
            <h1 className="font-semibold text-[20px] pt-4">Payments</h1>
        </div>

        <div className="grid gap-2 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 bg-white rounded-md shadow p-4 my-3 mb-2">
            <div className="flex flex-col">
                <div className="flex items-center p-2">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/profile/credit_card.png`}
                        className="mr-2 flex items-center justify-center bg-green-500 text-white rounded-lg w-12 h-12 p-3"
                    />
                    <div className="flex flex-col">
                        <p className="">Payment Successful</p>
                        <p className="font-normal text-[14px] text-[#606060]">from ABC Bank ATM</p>
                    </div>
                </div>
            </div>
            <div className="p-2 flex flex-col items-center justify-center">
                <p className="font-normal text-[#606060] text-[12px]">Transaction ID</p>
                <p className="font-normal text-[12px]">6567386242689</p>
            </div>
            <div className="p-2 flex flex-col items-center lg:justify-items-end lg:items-end">
                <p className="font-normal text-[14px]">$ 100.0</p>
                <p className="font-normal text-[10px] bg-green-500 text-white rounded-md p-1 w-auto">Confirmed</p>
                <p className="font-normal text-[#606060] text-[10px] mt-1">Dec 17 2024</p>
                <p className="font-normal text-[#606060] text-[10px]">10:30 AM</p>
            </div>
        </div>

        <div className="grid gap-2 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 bg-white rounded-md shadow p-4 my-3">
            <div className="flex flex-col">
                <div className="flex items-center p-2">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/profile/credit_card.png`}
                        className="mr-2 flex items-center justify-center bg-green-500 text-white rounded-lg w-12 h-12 p-3"
                    />
                    <div className="flex flex-col">
                        <p className="font-normal text-[14px]">Payment Successful</p>
                        <p className="font-normal text-[13px] text-[#606060]">from ABC Bank ATM</p>
                        <p className="font-normal text-[13px] text-[#606060]">Bank Server is Down</p>
                    </div>
                </div>
            </div>
            <div className="p-2 flex flex-col items-center justify-center">
                <p className="font-normal text-[#606060] text-[12px]">Transaction ID</p>
                <p className="font-normal text-[12px]">6567386242689</p>
            </div>
            <div className="p-2 flex flex-col items-center lg:justify-items-end lg:items-end">
                <p className="font-normal text-[14px]">$ 100.0</p>
                <p className="font-normal text-[10px] bg-yellow-500 text-white rounded-md p-1 w-auto">Pending</p>
                <p className="font-normal text-[#606060] text-[10px] mt-1">Dec 17 2024</p>
                <p className="font-normal text-[#606060] text-[10px]">10:30 AM</p>
            </div>
        </div>

    </div>
</div>

    )
}

export default ProfilePaymentCard